// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__pI1DP"};